import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorPage from "../../Components/ErrorPage";
import EmptyView from "../ViewComponents/EmptyView";
import DeleteRecordModal from "../ViewComponents/DeleteRecordModal";
import LoadingRows from "../ViewComponents/LoadingRows";
import TableAccess from "../TableEngine/TableAccess";

const MainAccess = ({ userData, no_session }) => {
    const { t } = useLanguage()
    const navigate = useNavigate();
    const { project_id } = useParams()
    const user_id = sessionStorage.getItem("user_id");
    const [records, setRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [activeFilter, setActiveFilter] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [animateReset, setAnimateReset] = useState(false)

    const new_item_navigate = `/project_panel/${project_id}/access/new_access`
    const title_empty = t.access.title
    const subtitle_empty = t.access.subtitle
    const item = "rabac"


    const navigateToNewProject = () => {
        navigate(new_item_navigate);
    };

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_access", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            if (response.ok) {
                const result = await response.json();
                let accessData = result.access || {};
                let filteredData = []; 

                for (let key in accessData) {
                    if (accessData[key].project_id === project_id) {
                        filteredData.push(accessData[key]); 
                    }
                }

                const recordsArray = Object.values(filteredData);

                setRecords(recordsArray);
                setFilteredRecords(recordsArray);
            } else {
                setError(true);
            }
        } catch (err) {
            setLoading(false)
            setError(true);
        }finally{
             setTimeout(() => {
                setLoading(false)
            }, 500);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, [user_id]);

    const handleSort = (criteria) => {
        setActiveFilter(criteria);
        let sortedRecords = [...records];
        if (criteria === "alphabetical") {
            sortedRecords.sort((a, b) => a.access_name.localeCompare(b.access_name));
        } else if (criteria === "reverseAlphabetical") {
            sortedRecords.sort((a, b) => b.access_name.localeCompare(a.access_name));
        } else if (criteria === "newest") {
            sortedRecords.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        } else if (criteria === "oldest") {
            sortedRecords.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        }
        setFilteredRecords(sortedRecords);
    };

    const resetFilters = () => {
        setActiveFilter("");
        setSearchQuery("")
        setAnimateReset(true)
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
        setFilteredRecords(records);
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter((record) => {
            return (
                record._id.toLowerCase().includes(query) ||
                record.project_id.toLowerCase().includes(query) ||
                record.access_name.toLowerCase().includes(query) ||
                record.access_surname.toLowerCase().includes(query) ||
                record.access_email.toLowerCase().includes(query) ||
                record.access_password.toLowerCase().includes(query) ||
                record.database.toLowerCase().includes(query) ||
                record.cluster.toLowerCase().includes(query) ||
                record.timestamp.toLowerCase().includes(query)

            );
        });

        setFilteredRecords(filtered);
    };

    const handleDeleteClick = (access_email) => {
        setSelectedRecordId(access_email);
        setShowDeleteModal(true);
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
        setSelectedRecordId(null);
    };

    const handleEditClick = (accID) => {
        const recordObject=records.find((record) => record._id === accID)
        sessionStorage.setItem("access_object", JSON.stringify(recordObject))
        navigate(`/project_panel/${project_id}/access/update_access/${accID}`)
    };


    if (loading) {
        return <LoadingRows />;
    } else if (error) {
        return <ErrorPage />;
    } else if (records.length === 0) {
        return <EmptyView navigate_link={new_item_navigate} title={title_empty} subtitle={subtitle_empty} item={item} />
    }

    return (
        <div className="main_view_container">
            <div className="header_main_view fade-in">
                <div className="header_title">
                    <p className="main_view_title">{t.access.main_title}</p>
                    <p className="main_view_subtitle">{t.access.main_subtitle}</p>
                    <button className="connect_email_btn" onClick={navigateToNewProject}>
                        <i className="fa-solid fa-plus"></i> {t.create}
                    </button>
                </div>
                {/* <img className="icon_img" src={item} alt="Access icon" /> */}
            </div>
            <div className="filter_container fade-in">
                {records.length > 1 && (
                    <>
                        <button
                            className={`filter_btn ${activeFilter === "alphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("alphabetical")}
                        >
                            <i className="fa-solid fa-arrow-down-wide-short"></i> A-Z
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "reverseAlphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("reverseAlphabetical")}
                        >
                            <i className="fa-solid fa-arrow-up-short-wide"></i> Z-A
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "newest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("newest")}
                        >
                            {t.from_newest}
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "oldest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("oldest")}
                        >
                            {t.from_oldest}
                        </button>
                    </>
                )}
                <button
                    className={`filter_btn ${activeFilter === "reset" ? "clicked_filter" : ""}`}
                    onClick={resetFilters}
                >
                    <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                </button>
                <div className="filter_input_cont">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                        className="filter_input"
                        placeholder={t.search}
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
            </div>
            <div className="organizations_cont">
                <TableAccess data={filteredRecords} handleDeleteClick={handleDeleteClick} handleEditClick={handleEditClick} />
            </div>

            <DeleteRecordModal
                show={showDeleteModal}
                handleClose={handleCloseModal}
                recordObject={records.find((record) => record.access_email === selectedRecordId)}
                fetchRecords={fetchRecords}
                endpoint={"delete_access"}
                record_type={selectedRecordId}
                message= "This action CANNOT be undone. It will permanently delete the resource and all associated data."
            />
        </div>
    );
};

export default MainAccess;
